import React from "react";
import '../../App.css';




function Photos() {
    
    return  <>  
    <div>
    <h1>Photos welcomes you</h1>
    </div>
   
     </>
}

export default Photos;